/* Enhance native Dawn disclosure menus only for fine-pointer desktop devices. */
(() => {
  class KslBrandNavigation extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const desktop = () => matchMedia('(min-width:990px) and (hover:hover) and (pointer:fine)').matches;
      this.querySelectorAll('header-menu').forEach(menu => {
        const details = menu.querySelector('details');
        details.addEventListener('toggle', () => details.querySelector('summary').setAttribute('aria-expanded', String(details.open)), options);
        menu.addEventListener('pointerenter', () => {
          if (!desktop()) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.querySelectorAll('header-menu details[open]').forEach(other => { if (other !== details) other.open = false; });
            details.open = true;
          }, 120);
        }, options);
        menu.addEventListener('pointerleave', () => {
          clearTimeout(this.timer);
          if (!desktop()) return;
          this.timer = setTimeout(() => { if (!menu.contains(document.activeElement)) details.open = false; }, 200);
        }, options);
      });
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = this.querySelector('header-menu details[open]');
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      }, options);
    }
    close() { clearTimeout(this.timer); this.querySelectorAll('header-menu details[open]').forEach(details => { details.open = false; }); }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
  }
  if (!customElements.get('ksl-brand-navigation')) customElements.define('ksl-brand-navigation', KslBrandNavigation);
})();
